import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { SaveCriteriaModalsModel } from '../..//models/save-criteria-modals.model';

// identifier
export const SAVE_CRITERIA_MODALS_SLICE_ID = 'saveCriteriaModals';

// default state
const initialState: SaveCriteriaModalsModel = {
  saveVisible: false,
  createAlertVisible: false,
  deleteFilter: undefined,
  subscribeFilter: undefined,
};

//slice
const saveCriteriaModalsSlice = createSlice({
  name: SAVE_CRITERIA_MODALS_SLICE_ID,
  initialState,
  reducers: {
    showSaveCriteria: (state: SaveCriteriaModalsModel): void => {
      state.saveVisible = true;
    },
    hideSaveCriteria: (state: SaveCriteriaModalsModel): void => {
      state.saveVisible = false;
    },
    showCreateAlert: (state: SaveCriteriaModalsModel): void => {
      state.createAlertVisible = true;
    },
    hideCreateAlert: (state: SaveCriteriaModalsModel): void => {
      state.createAlertVisible = false;
    },
    setDeleteFilter: (
      state: SaveCriteriaModalsModel,
      action: PayloadAction<number | undefined>
    ): void => {
      state.deleteFilter = action.payload;
    },
    setSubscribeFilter: (
      state: SaveCriteriaModalsModel,
      action: PayloadAction<number | undefined>
    ): void => {
      state.subscribeFilter = action.payload;
    },
  },
});

//selectors

export const selectSaveCriteriaVisible = (state: RootState) => state.saveCriteriaModals.saveVisible;

export const selectCreateAlertVisible = (state: RootState) =>
  state.saveCriteriaModals.createAlertVisible;

export const selectDeleteFilter = (state: RootState) => state.saveCriteriaModals.deleteFilter;

export const selectSubscribeFilter = (state: RootState) => state.saveCriteriaModals.subscribeFilter;

//actions
export const {
  showCreateAlert,
  hideCreateAlert,
  showSaveCriteria,
  hideSaveCriteria,
  setDeleteFilter,
  setSubscribeFilter,
} = saveCriteriaModalsSlice.actions;

//reducer
export default saveCriteriaModalsSlice;
